export default function CloudServerRouter(Layout, device) {
  console.log('CloudServerRouter---', device);
  return [
    {
      path: '/cloudServer',
      name: 'cloudServer',
      redirect: '/cloudServer/index',
      component: Layout,
      meta: {
        title: '沙盒服务器',
        icon: 'icon-cloudServ',
        activePath: 'cloudServer',
      },
      children: [
        {
          path: 'index',
          name: 'cloudServerHome',
          redirect: '/cloudServer/index/manager',
          component: () => import(`../views/${device}/index.vue`),
          meta: {
            title: '服务器概况',
            activePath: 'cloudServer',
          },
          children: [
            {
              path: 'manager',
              name: 'cloudServerManager',
              component: () => import(`../views/${device}/manager.vue`),
              meta: {
                title: '沙盒服务器管理',
                activePath: 'cloudServer',
                showSideBar: true,
              },
            },
            {
              path: 'buy/:type',
              name: 'cloudServerBuy',
              component: () => import(`../views/${device}/buy.vue`),
              meta: {
                title: '购买服务器',
                activePath: 'cloudServer',
              },
            },
            {
              path: 'data/:currServ',
              name: 'cloudServerData',
              component: () => import(`../views/${device}/data.vue`),
              meta: {
                title: '服务器数据',
                activePath: 'cloudServer',
              },
            },
            {
              path: 'pay',
              name: 'cloudServerPay',
              component: () => import(`../views/${device}/pay.vue`),
              meta: {
                title: '升级/续费服务器',
                activePath: 'cloudServer',
              },
            },
            {
              path: 'orderList',
              name: 'cloudServerOrderList',
              component: () => import(`../views/${device}/orderList.vue`),
              meta: {
                title: '交易记录',
                activePath: 'cloudServer',
              },
            },
            {
              path: 'orderDetails/:id',
              name: 'cloudServerOrderDetails',
              component: () => import(`../views/${device}/orderDetails.vue`),
              meta: {
                title: '订单详情',
                activePath: 'cloudServer',
              },
            },
            {
              path: 'noAny',
              name: 'cloudServerNoAny',
              component: () => import(`../views/${device}/noAny.vue`),
              meta: {
                title: '沙盒服务器',
                activePath: 'cloudServer',
              },
            },
          ],
        },
      ],
    },
  ];
}
